import React from 'react';
import { Bell, X } from 'lucide-react';
import { useZunelo } from '../../context/ZuneloContext';
import './notifications.css';

export const ForegroundNotificationToast: React.FC = () => {
  const { foregroundNotification, dismissForegroundNotification } = useZunelo();
  if (!foregroundNotification) return null;
  const href = foregroundNotification.appPath ?? foregroundNotification.externalUrl;
  return (
    <aside className="z-notification-toast" role="status" aria-live="polite">
      <Bell size={18} aria-hidden="true" />
      <div>
        <strong>{foregroundNotification.title}</strong>
        {foregroundNotification.body ? <span>{foregroundNotification.body}</span> : null}
        {href ? <a href={href}>Abrir ahora</a> : null}
      </div>
      <button type="button" aria-label="Cerrar aviso" onClick={dismissForegroundNotification}>
        <X size={16} aria-hidden="true" />
      </button>
    </aside>
  );
};
